<p class="f-small text-center">
    <span class="text-decoration-line-through text-danger">{{originalDate | localDate}}</span>
    <span> {{rowData.extendedDueDate | localDate}}</span>
</p>
